export interface ModeSettingType {
    modeTypeId: number;
    settingTypeId: number;
}

// Mode Type Constants
export const MODE_TYPE_LOCKED: number = 1;
export const MODE_TYPE_UNLOCKED: number = 2;
export const MODE_TYPE_CARD_ONLY: number = 3;
export const MODE_TYPE_CARD_AND_PIN: number = 4;
export const MODE_TYPE_CARD_WITH_REASON_CODE: number = 5;
export const MODE_TYPE_CARD_AND_PIN_WITH_REASON_CODE: number = 6;
export const MODE_TYPE_EMERGENCY: number = 7;
export const MODE_TYPE_PERSONAL_ACCESS_CODE: number = 8;
export const MODE_TYPE_CARD_PLUS_FINGER: number = 9;
export const MODE_TYPE_LOCKDOWN: number = 10;
export const MODE_TYPE_ARMED: number = 11;
export const MODE_TYPE_CARD_OR_FINGER: number = 12;
export const MODE_TYPE_FINGER_ONLY: number = 13;
export const MODE_TYPE_CARD_AND_FINGER_WITH_PIN: number = 14;
export const MODE_TYPE_CARD_AND_FINGER_WITH_REASON_CODE: number = 15;
export const MODE_TYPE_CARD_AND_FINGER_WITH_PIN_AND_REASON_CODE: number = 16;
export const MODE_TYPE_CARD_OR_FINGER_WITH_PIN: number = 17;
export const MODE_TYPE_CARD_OR_FINGER_WITH_REASON_CODE: number = 18;
export const MODE_TYPE_FINGER_WITH_PIN: number = 20;
export const MODE_TYPE_FINGER_WITH_REASON_CODE: number = 21;
export const MODE_TYPE_FINGER_WITH_PIN_AND_REASON_CODE: number = 22;
export const MODE_TYPE_PERSONAL_ACCESS_CODE_AND_FINGER: number = 23;
export const MODE_TYPE_PERSONAL_ACCESS_CODE_OR_FINGER: number = 24;
export const MODE_TYPE_CARD_OR_FINGER_OR_PAC_AND_FINGER: number = 25;
export const MODE_TYPE_TEMPLATE_ON_CARD: number = 26;
export const MODE_TYPE_UNLOCK_ON_FIRST_TAG: number = 27;
export const MODE_TYPE_OFFICE_MODE_TAG: number = 28;
export const MODE_TYPE_OFFICE_MODE_PAC: number = 29;

// Setting Type Constants
export const SETTING_TYPE_LOCKED: number = 3001;
export const SETTING_TYPE_UNLOCK: number = 3002;
export const SETTING_TYPE_CARD_ONLY: number = 3003;
export const SETTING_TYPE_CARD_AND_PIN: number = 3004;
export const SETTING_TYPE_CARD_WITH_REASON_CODE: number = 3005;
export const SETTING_TYPE_CARD_AND_PIN_WITH_REASON_CODE: number = 3006;
export const SETTING_TYPE_EMERGENCY: number = 30007;
export const SETTING_TYPE_PERSONAL_ACCESS_CODE: number = 3008;
export const SETTING_TYPE_CARD_PLUS_FINGER: number = 3009;
export const SETTING_TYPE_LOCKDOWN: number = 3010;
export const SETTING_TYPE_ARMED: number = 3011;
export const SETTING_TYPE_CARD_OR_FINGER: number = 3012;
export const SETTING_TYPE_FINGER_ONLY: number = 3013;
export const SETTING_TYPE_CARD_AND_FINGER_WITH_PIN: number = 3014;
export const SETTING_TYPE_CARD_AND_FINGER_WITH_REASON_CODE: number = 3015;
export const SETTING_TYPE_CARD_AND_FINGER_WITH_PIN_AND_REASON_CODE: number = 3016;
export const SETTING_TYPE_CARD_OR_FINGER_WITH_PIN: number = 3017;
export const SETTING_TYPE_CARD_OR_FINGER_WITH_REASON_CODE: number = 3018;
export const SETTING_TYPE_FINGER_WITH_PIN: number = 3020;
export const SETTING_TYPE_FINGER_WITH_REASON_CODE: number = 3021;
export const SETTING_TYPE_FINGER_WITH_PIN_AND_REASON_CODE: number = 3022;
export const SETTING_TYPE_PERSONAL_ACCESS_CODE_AND_FINGER: number = 3023;
export const SETTING_TYPE_PERSONAL_ACCESS_CODE_OR_FINGER: number = 3024;
export const SETTING_TYPE_CARD_OR_FINGER_OR_PAC_AND_FINGER: number = 3025;
export const SETTING_TYPE_TEMPLATE_ON_CARD: number = 3026;
export const SETTING_TYPE_UNLOCK_ON_FIRST_TAG: number = 3027;
export const SETTING_TYPE_OFFICE_MODE_TAG: number = 3028;
export const SETTING_TYPE_OFFICE_MODE_PAC: number = 3029;

export const MODE_TYPE_SUPPORTED_BY_IO_MODULE : ModeSettingType[] = [
    {modeTypeId: MODE_TYPE_UNLOCKED, settingTypeId: SETTING_TYPE_UNLOCK },
]

export const MODE_TYPE_SUPPORTED_BY_IO_MODULE_PRESET_OUTPUT: ModeSettingType[] = [
    {modeTypeId: MODE_TYPE_UNLOCKED, settingTypeId: SETTING_TYPE_UNLOCK },
    {modeTypeId: MODE_TYPE_EMERGENCY, settingTypeId: SETTING_TYPE_EMERGENCY },
    {modeTypeId: MODE_TYPE_LOCKDOWN, settingTypeId: SETTING_TYPE_LOCKDOWN },
]

export const MODE_TYPE_NOT_SUPPORTED_BY_BIOMETRIC: ModeSettingType[] = [
    {modeTypeId: MODE_TYPE_TEMPLATE_ON_CARD, settingTypeId: SETTING_TYPE_TEMPLATE_ON_CARD },
    {modeTypeId: MODE_TYPE_EMERGENCY, settingTypeId: SETTING_TYPE_EMERGENCY },
    {modeTypeId: MODE_TYPE_LOCKDOWN, settingTypeId: SETTING_TYPE_LOCKDOWN },
    {modeTypeId: MODE_TYPE_ARMED, settingTypeId: SETTING_TYPE_ARMED }
];

export const MODE_TYPE_NOT_SUPPORTED_BY_BIOMETRIC_PRESET_OUTPUT: ModeSettingType[] = [
    {modeTypeId: MODE_TYPE_TEMPLATE_ON_CARD, settingTypeId: SETTING_TYPE_TEMPLATE_ON_CARD },
    {modeTypeId: MODE_TYPE_ARMED, settingTypeId: SETTING_TYPE_ARMED }
];

export const MODE_TYPE_SUPPORTED_BY_IMPROX_READER: ModeSettingType[] = [
    {modeTypeId: MODE_TYPE_LOCKED, settingTypeId: SETTING_TYPE_LOCKED },
    {modeTypeId: MODE_TYPE_UNLOCKED, settingTypeId: SETTING_TYPE_UNLOCK },
    {modeTypeId: MODE_TYPE_CARD_ONLY, settingTypeId: SETTING_TYPE_CARD_ONLY },
    {modeTypeId: MODE_TYPE_CARD_AND_PIN, settingTypeId: SETTING_TYPE_CARD_AND_PIN },
    {modeTypeId: MODE_TYPE_CARD_WITH_REASON_CODE, settingTypeId: SETTING_TYPE_CARD_WITH_REASON_CODE },
    {modeTypeId: MODE_TYPE_CARD_AND_PIN_WITH_REASON_CODE, settingTypeId: SETTING_TYPE_CARD_AND_PIN_WITH_REASON_CODE },
    {modeTypeId: MODE_TYPE_PERSONAL_ACCESS_CODE, settingTypeId: SETTING_TYPE_PERSONAL_ACCESS_CODE },
    {modeTypeId: MODE_TYPE_UNLOCK_ON_FIRST_TAG, settingTypeId: SETTING_TYPE_UNLOCK_ON_FIRST_TAG },
    {modeTypeId: MODE_TYPE_OFFICE_MODE_TAG, settingTypeId: SETTING_TYPE_OFFICE_MODE_TAG },
    {modeTypeId: MODE_TYPE_OFFICE_MODE_PAC, settingTypeId: SETTING_TYPE_OFFICE_MODE_PAC }
];

export const MODE_TYPE_SUPPORTED_BY_IMPROX_READER_PRESET_OUTPUT: ModeSettingType[] = [
    {modeTypeId: MODE_TYPE_LOCKED, settingTypeId: SETTING_TYPE_LOCKED },
    {modeTypeId: MODE_TYPE_UNLOCKED, settingTypeId: SETTING_TYPE_UNLOCK },
    {modeTypeId: MODE_TYPE_CARD_ONLY, settingTypeId: SETTING_TYPE_CARD_ONLY },
    {modeTypeId: MODE_TYPE_CARD_AND_PIN, settingTypeId: SETTING_TYPE_CARD_AND_PIN },
    {modeTypeId: MODE_TYPE_CARD_WITH_REASON_CODE, settingTypeId: SETTING_TYPE_CARD_WITH_REASON_CODE },
    {modeTypeId: MODE_TYPE_CARD_AND_PIN_WITH_REASON_CODE, settingTypeId: SETTING_TYPE_CARD_AND_PIN_WITH_REASON_CODE },
    {modeTypeId: MODE_TYPE_PERSONAL_ACCESS_CODE, settingTypeId: SETTING_TYPE_PERSONAL_ACCESS_CODE },
    {modeTypeId: MODE_TYPE_UNLOCK_ON_FIRST_TAG, settingTypeId: SETTING_TYPE_UNLOCK_ON_FIRST_TAG },
    {modeTypeId: MODE_TYPE_OFFICE_MODE_TAG, settingTypeId: SETTING_TYPE_OFFICE_MODE_TAG },
    {modeTypeId: MODE_TYPE_OFFICE_MODE_PAC, settingTypeId: SETTING_TYPE_OFFICE_MODE_PAC },
    {modeTypeId: MODE_TYPE_EMERGENCY, settingTypeId: SETTING_TYPE_EMERGENCY },
    {modeTypeId: MODE_TYPE_LOCKDOWN, settingTypeId: SETTING_TYPE_LOCKDOWN }
];

export const MODE_TYPE_SUPPORTED_BY_EL_LOCK: ModeSettingType[] = [
    {modeTypeId: MODE_TYPE_LOCKED, settingTypeId: SETTING_TYPE_LOCKED },
    {modeTypeId: MODE_TYPE_UNLOCKED, settingTypeId: SETTING_TYPE_UNLOCK },
    {modeTypeId: MODE_TYPE_CARD_ONLY, settingTypeId: SETTING_TYPE_CARD_ONLY },
    {modeTypeId: MODE_TYPE_CARD_AND_PIN, settingTypeId: SETTING_TYPE_CARD_AND_PIN },
    {modeTypeId: MODE_TYPE_CARD_WITH_REASON_CODE, settingTypeId: SETTING_TYPE_CARD_WITH_REASON_CODE },
    {modeTypeId: MODE_TYPE_CARD_AND_PIN_WITH_REASON_CODE, settingTypeId: SETTING_TYPE_CARD_AND_PIN_WITH_REASON_CODE },
    {modeTypeId: MODE_TYPE_PERSONAL_ACCESS_CODE, settingTypeId: SETTING_TYPE_PERSONAL_ACCESS_CODE },
    {modeTypeId: MODE_TYPE_UNLOCK_ON_FIRST_TAG, settingTypeId: SETTING_TYPE_UNLOCK_ON_FIRST_TAG },
    {modeTypeId: MODE_TYPE_OFFICE_MODE_TAG, settingTypeId: SETTING_TYPE_OFFICE_MODE_TAG },
    {modeTypeId: MODE_TYPE_OFFICE_MODE_PAC, settingTypeId: SETTING_TYPE_OFFICE_MODE_PAC }
];

export const MODE_TYPE_SUPPORTED_BY_EL_LOCK_PRESET_OUTPUT: ModeSettingType[] = [
    {modeTypeId: MODE_TYPE_LOCKED, settingTypeId: SETTING_TYPE_LOCKED },
    {modeTypeId: MODE_TYPE_UNLOCKED, settingTypeId: SETTING_TYPE_UNLOCK },
    {modeTypeId: MODE_TYPE_CARD_ONLY, settingTypeId: SETTING_TYPE_CARD_ONLY },
    {modeTypeId: MODE_TYPE_CARD_AND_PIN, settingTypeId: SETTING_TYPE_CARD_AND_PIN },
    {modeTypeId: MODE_TYPE_CARD_WITH_REASON_CODE, settingTypeId: SETTING_TYPE_CARD_WITH_REASON_CODE },
    {modeTypeId: MODE_TYPE_CARD_AND_PIN_WITH_REASON_CODE, settingTypeId: SETTING_TYPE_CARD_AND_PIN_WITH_REASON_CODE },
    {modeTypeId: MODE_TYPE_PERSONAL_ACCESS_CODE, settingTypeId: SETTING_TYPE_PERSONAL_ACCESS_CODE },
    {modeTypeId: MODE_TYPE_UNLOCK_ON_FIRST_TAG, settingTypeId: SETTING_TYPE_UNLOCK_ON_FIRST_TAG },
    {modeTypeId: MODE_TYPE_OFFICE_MODE_TAG, settingTypeId: SETTING_TYPE_OFFICE_MODE_TAG },
    {modeTypeId: MODE_TYPE_OFFICE_MODE_PAC, settingTypeId: SETTING_TYPE_OFFICE_MODE_PAC },
    {modeTypeId: MODE_TYPE_EMERGENCY, settingTypeId: SETTING_TYPE_EMERGENCY },
    {modeTypeId: MODE_TYPE_LOCKDOWN, settingTypeId: SETTING_TYPE_LOCKDOWN }
];

export const MODE_TYPE_SUPPORTED_BY_APERIO: ModeSettingType[] = [
    {modeTypeId: MODE_TYPE_LOCKED, settingTypeId: SETTING_TYPE_LOCKED },
    {modeTypeId: MODE_TYPE_UNLOCKED, settingTypeId: SETTING_TYPE_UNLOCK },
    {modeTypeId: MODE_TYPE_CARD_ONLY, settingTypeId: SETTING_TYPE_CARD_ONLY },
    {modeTypeId: MODE_TYPE_CARD_AND_PIN, settingTypeId: SETTING_TYPE_CARD_AND_PIN },
    {modeTypeId: MODE_TYPE_CARD_WITH_REASON_CODE, settingTypeId: SETTING_TYPE_CARD_WITH_REASON_CODE },
    {modeTypeId: MODE_TYPE_CARD_AND_PIN_WITH_REASON_CODE, settingTypeId: SETTING_TYPE_CARD_AND_PIN_WITH_REASON_CODE },
    {modeTypeId: MODE_TYPE_PERSONAL_ACCESS_CODE, settingTypeId: SETTING_TYPE_PERSONAL_ACCESS_CODE },
    {modeTypeId: MODE_TYPE_UNLOCK_ON_FIRST_TAG, settingTypeId: SETTING_TYPE_UNLOCK_ON_FIRST_TAG },
    {modeTypeId: MODE_TYPE_OFFICE_MODE_TAG, settingTypeId: SETTING_TYPE_OFFICE_MODE_TAG },
    {modeTypeId: MODE_TYPE_OFFICE_MODE_PAC, settingTypeId: SETTING_TYPE_OFFICE_MODE_PAC }
];

export const MODE_TYPE_SUPPORTED_BY_APERIO_PRESET_OUTPUT: ModeSettingType[] = [
    {modeTypeId: MODE_TYPE_LOCKED, settingTypeId: SETTING_TYPE_LOCKED },
    {modeTypeId: MODE_TYPE_UNLOCKED, settingTypeId: SETTING_TYPE_UNLOCK },
    {modeTypeId: MODE_TYPE_CARD_ONLY, settingTypeId: SETTING_TYPE_CARD_ONLY },
    {modeTypeId: MODE_TYPE_CARD_AND_PIN, settingTypeId: SETTING_TYPE_CARD_AND_PIN },
    {modeTypeId: MODE_TYPE_CARD_WITH_REASON_CODE, settingTypeId: SETTING_TYPE_CARD_WITH_REASON_CODE },
    {modeTypeId: MODE_TYPE_CARD_AND_PIN_WITH_REASON_CODE, settingTypeId: SETTING_TYPE_CARD_AND_PIN_WITH_REASON_CODE },
    {modeTypeId: MODE_TYPE_PERSONAL_ACCESS_CODE, settingTypeId: SETTING_TYPE_PERSONAL_ACCESS_CODE },
    {modeTypeId: MODE_TYPE_UNLOCK_ON_FIRST_TAG, settingTypeId: SETTING_TYPE_UNLOCK_ON_FIRST_TAG },
    {modeTypeId: MODE_TYPE_OFFICE_MODE_TAG, settingTypeId: SETTING_TYPE_OFFICE_MODE_TAG },
    {modeTypeId: MODE_TYPE_OFFICE_MODE_PAC, settingTypeId: SETTING_TYPE_OFFICE_MODE_PAC },
    {modeTypeId: MODE_TYPE_EMERGENCY, settingTypeId: SETTING_TYPE_EMERGENCY },
    {modeTypeId: MODE_TYPE_LOCKDOWN, settingTypeId: SETTING_TYPE_LOCKDOWN }
];
